var exports = {
  "kL": "xdbfd91f1--e7b5d8--container",
  "DD": "xdbfd91f1--e7b5d8--title",
  "nf": "xdbfd91f1--e7b5d8--link",
};

module.exports = exports;
